import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';

import { CepService, CustomValidators, Pattern } from 'viggo-sistemas-core-web';

import { IMunicipio } from '@app/modules/parametrizacao/municipio/model/municipio.model';
import { MunicipioService } from '@app/modules/parametrizacao/municipio/services/municipio.service';
import { IParceiro, IParceiroEndereco } from '@app/modules/parceiro/model';
import { Utils } from '@app/shared/helpers/utils';
import { CepPipe } from '@app/shared/pipes';
import { locationValidationMessages } from '@app/shared/validation.message';
import { IPais } from '../../../parametrizacao/paises/model/pais.model';
import { PaisService } from '../../../parametrizacao/paises/services/paises.service';
@Component({
  selector: 'app-fast-endereco',
  templateUrl: './fast-endereco.component.html',
  styleUrls: ['./fast-endereco.component.scss'],
  providers: [MunicipioService, CepService, PaisService]
})
export class FastEnderecoComponent implements OnInit, OnChanges {
  @ViewChild('logradouro')
  private logradouro: ElementRef<HTMLInputElement>;

  @ViewChild('pais')
  private pais: ElementRef<HTMLInputElement>;

  @Input() entity: IParceiro;

  @Input() readonly = false;

  @Input() showCodPais = false;

  @Input() insertDocEstrangeiro = false;

  form: UntypedFormGroup;

  cepPipe: CepPipe;
  messages = locationValidationMessages;

  constructor(
    protected fb: UntypedFormBuilder,
    public cepService: CepService,
    public municipioService: MunicipioService,
    public paisService: PaisService
  ) {
    this.cepPipe = new CepPipe();
  }

  getValue(value: string) {
    if (this.entity.enderecos.length > 0) {
      return this.entity.enderecos[0][value];
    }
    return null;
  }

  public objectForm() {
    if (this.showCodPais) {
      if (this.readonly) {
        return {
          logradouro: [this.getValue('logradouro')],
          numero: [this.getValue('numero')],
          complemento: [this.getValue('complemento')],
          pais: [this.getValue('pais')],
          bairro: [this.getValue('bairro')],
          cep: [this.getValue('cep')],
          ponto_referencia: [this.getValue('ponto_referencia')],
          municipio: [this.getValue('municipio')]
        };
      } else {
        if (this.insertDocEstrangeiro) {
          return {
            logradouro: [
              this.getValue('logradouro'),
              [Validators.maxLength(255), CustomValidators.isEmptyValue()]
            ],
            numero: [
              this.getValue('numero'),
              [Validators.maxLength(60), CustomValidators.isEmptyValue()]
            ],
            complemento: [
              this.getValue('complemento'),
              [
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            pais: [
              this.getValue('pais'),
              [
                Validators.required,
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ],
            bairro: [
              this.getValue('bairro'),
              [
                Validators.minLength(3),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            cep: [this.getValue('cep')],
            ponto_referencia: [
              this.getValue('ponto_referencia'),
              [Validators.maxLength(500), CustomValidators.isEmptyValue()]
            ],
            municipio: [
              this.getValue('municipio'),
              [
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ]
          };
        } else {
          return {
            logradouro: [
              this.getValue('logradouro'),
              [
                Validators.required,
                Validators.maxLength(255),
                CustomValidators.isEmptyValue()
              ]
            ],
            numero: [
              this.getValue('numero'),
              [
                Validators.required,
                Validators.pattern(Pattern.patternNumberAndLetters(1, 60)),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            complemento: [
              this.getValue('complemento'),
              [
                Validators.maxLength(60),
                Validators.minLength(1),
                CustomValidators.isEmptyValue()
              ]
            ],
            pais: [
              this.getValue('pais'),
              !this.entity.id
                ? [Validators.required, CustomValidators.typeIs('object')]
                : [CustomValidators.typeIs('object')]
            ],
            bairro: [
              this.getValue('bairro'),
              [
                Validators.minLength(3),
                Validators.maxLength(60),
                Validators.required,
                CustomValidators.isEmptyValue()
              ]
            ],
            cep: [
              this.getValue('cep'),
              [
                Validators.required,
                Validators.pattern(Pattern.patternCep()),
                CustomValidators.isEmptyValue()
              ]
            ],
            ponto_referencia: [
              this.getValue('ponto_referencia'),
              [Validators.maxLength(500), CustomValidators.isEmptyValue()]
            ],
            municipio: [
              this.getValue('municipio'),
              [
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue(),
                Validators.required
              ]
            ]
          };
        }
      }
    } else {
      if (this.readonly) {
        return {
          logradouro: [this.getValue('logradouro')],
          numero: [this.getValue('numero')],
          complemento: [this.getValue('complemento')],
          bairro: [this.getValue('bairro')],
          cep: [this.getValue('cep')],
          ponto_referencia: [this.getValue('ponto_referencia')],
          municipio: [this.getValue('municipio')]
        };
      } else {
        return {
          logradouro: [
            this.getValue('logradouro'),
            [
              Validators.required,
              Validators.maxLength(255),
              CustomValidators.isEmptyValue()
            ]
          ],
          numero: [
            this.getValue('numero'),
            [
              Validators.required,
              Validators.pattern(Pattern.patternNumberAndLetters(1, 60)),
              Validators.maxLength(60),
              CustomValidators.isEmptyValue()
            ]
          ],
          complemento: [
            this.getValue('complemento'),
            [
              Validators.maxLength(60),
              Validators.minLength(1),
              CustomValidators.isEmptyValue()
            ]
          ],
          bairro: [
            this.getValue('bairro'),
            [
              Validators.minLength(3),
              Validators.maxLength(60),
              Validators.required,
              CustomValidators.isEmptyValue()
            ]
          ],
          cep: [
            this.getValue('cep'),
            [
              Validators.required,
              Validators.pattern(Pattern.patternCep()),
              CustomValidators.isEmptyValue()
            ]
          ],
          ponto_referencia: [
            this.getValue('ponto_referencia'),
            [Validators.maxLength(500), CustomValidators.isEmptyValue()]
          ],
          municipio: [
            this.getValue('municipio'),
            [
              CustomValidators.typeIs('object'),
              Validators.required,
              CustomValidators.isEmptyValue()
            ]
          ]
        };
      }
    }
  }

  ngOnChanges() {
    if (this.showCodPais && this.form) {
      if (this.insertDocEstrangeiro) {
        this.changeForm(true);
        this.changeValidateForm(true);
      } else {
        this.changeForm(false);
        this.changeValidateForm(false);
      }
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group(this.objectForm());
    this.form.controls.municipio.valueChanges.subscribe(
      (municipio?: IMunicipio) => {
        const cepForm = this.form.controls.cep;

        if (!municipio || !cepForm.value) cepForm.setValue('');
        if (typeof municipio !== 'object') cepForm.setValue('');
        if (municipio && municipio.cep)
          cepForm.setValue(this.cepPipe.transform(municipio.cep));
      }
    );
    if (this.entity.enderecos.length > 0) {
      this.checkCep(this.entity.enderecos[0].cep);
    }
  }
  /**
   * Desabilitar/Habilita os controls do form address
   * @param form
   */
  changeForm(disabled: boolean) {
    const {
      cep,
      municipio,
      logradouro,
      bairro,
      complemento,
      numero,
      ponto_referencia
    } = this.form.controls;
    if (disabled) {
      cep.disable();
      municipio.disable();
      logradouro.disable();
      complemento.disable();
      bairro.disable();
      numero.disable();
      ponto_referencia.disable();
    } else {
      cep.enable();
      municipio.enable();
      logradouro.enable();
      complemento.enable();
      bairro.enable();
      numero.enable();
      ponto_referencia.enable();
    }
  }

  /**
   * Altera as validações dos controls do form address
   * @param form
   */
  changeValidateForm(validate: boolean) {
    const {
      logradouro,
      pais,
      numero,
      bairro,
      cep,
      municipio
    } = this.form.controls;
    if (validate) {
      pais.addValidators([Validators.required]);
      pais.setErrors({ required: true });
      logradouro.removeValidators(Validators.required);
      logradouro.setErrors(null);
      numero.removeValidators(Validators.required);
      numero.setErrors(null);
      bairro.removeValidators(Validators.required);
      bairro.setErrors(null);
      cep.removeValidators(Validators.required);
      cep.setErrors(null);
      municipio.removeValidators(Validators.required);
      municipio.setErrors(null);
      logradouro.updateValueAndValidity();
      logradouro.markAsTouched();
      numero.updateValueAndValidity();
      numero.markAsTouched();
      bairro.updateValueAndValidity();
      bairro.markAsTouched();
      cep.updateValueAndValidity();
      cep.markAsTouched();
      municipio.updateValueAndValidity();
      municipio.markAsTouched();
    } else {
      pais.removeValidators(Validators.required);
      pais.setErrors(null);
      logradouro.addValidators(Validators.required);
      numero.addValidators(Validators.required);
      bairro.addValidators(Validators.required);
      cep.addValidators(Validators.required);
      municipio.addValidators(Validators.required);
      logradouro.updateValueAndValidity();
      logradouro.markAsTouched();
      numero.updateValueAndValidity();
      numero.markAsTouched();
      bairro.updateValueAndValidity();
      bairro.markAsTouched();
      cep.updateValueAndValidity();
      cep.markAsTouched();
      municipio.updateValueAndValidity();
      municipio.markAsTouched();
      pais.updateValueAndValidity();
      pais.markAsTouched();
    }
  }

  checkCep(cep: string): void {
    const { form } = this;
    // verifica se o campo foi tocado pelo usuário e está válido
    if (form.controls.cep.valid) {
      // caso o municipio esteja setado, verifica se o cep inserido é igual o cep digitado

      form.controls.cep.setValue(this.cepPipe.transform(cep));
      // pega o cep pela api
      this.cepService.getAddres(cep).subscribe(
        addres => {
          // caso acheo local, preenche as informações dos campos
          const { controls } = form;

          if (addres.ibge && addres.localidade) {
            this.municipioService
              .getEntitiesByParams(`codigo_ibge=${addres.ibge}`)
              .subscribe(municipios => {
                if (municipios && municipios.length)
                  controls.municipio.setValue(municipios[0]);
                else controls.municipio.setValue(addres.localidade);
                // this.showCodPais
                //   ? this.focarNoPais()
                //   : this.focarNoLogradouro();
              });
          }

          if (addres.logradouro)
            controls.logradouro.setValue(addres.logradouro);
          if (addres.bairro) controls.bairro.setValue(addres.bairro);
          if (addres.complemento)
            controls.complemento.setValue(addres.complemento);
        },
        () => {
          // caso não ache um endereço adiciona o erro ao input de cep
          form.controls.cep.setErrors({ notFound: true });
          form.updateValueAndValidity();
        }
      );
    }
  }

  private focarNoLogradouro(): void {
    this.logradouro.nativeElement.focus();
    // da o click no campo de logradouro para sair do campo de autocomplete
  }

  private focarNoPais(): void {
    this.pais.nativeElement.focus();
    // da o click no campo de logradouro para sair do campo de autocomplete
  }

  public updateFormValue(enderecos: IParceiroEndereco[]): void {
    if (!enderecos || !enderecos.length) this.resetForm();
    else
      this.municipioService
        .getEntity(enderecos[0].municipio_id)
        .subscribe(municipio => {
          const updatedValue: IParceiroEndereco = this.showCodPais
            ? ({
                bairro: enderecos[0].bairro || '',
                cep: enderecos[0].cep || '',
                complemento: enderecos[0].complemento || '',
                logradouro: enderecos[0].logradouro || '',
                numero: enderecos[0].numero || '',
                ponto_referencia: enderecos[0].ponto_referencia || '',
                pais: this.insertDocEstrangeiro ? enderecos[0].pais : null,
                municipio
              } as IParceiroEndereco)
            : ({
                bairro: enderecos[0].bairro || '',
                cep: enderecos[0].cep || '',
                complemento: enderecos[0].complemento || '',
                logradouro: enderecos[0].logradouro || '',
                numero: enderecos[0].numero || '',
                ponto_referencia: enderecos[0].ponto_referencia || '',
                municipio
              } as IParceiroEndereco);
          this.form.patchValue({
            ...updatedValue
          });
        });
  }

  private resetForm(): void {
    this.form.reset();
  }

  paisDisplay = (entity: IPais): string => {
    if (entity) {
      return entity.codigo + ' - ' + entity.nome;
    }
    return '';
  };

  getValues(): IParceiroEndereco[] {
    const { value } = this.form;

    const endereco = [
      Utils.trimAttributes(
        Utils.clearObject({
          ...value,
          municipio: undefined,
          pais: undefined,
          cep: this.insertDocEstrangeiro ? null : value.cep.replace(/\D/g, ''),
          municipio_id: this.insertDocEstrangeiro ? null : value.municipio.id,
          pais_id: value.pais ? value.pais.id : null
        })
      )
    ];

    return endereco;
  }
}
